// firebase-config.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBKIP4T8THLLqfyy2rDYIE4jF8sxHcsEO0",
  authDomain: "pipaan-app-dev.firebaseapp.com",
  projectId: "pipaan-app-dev",
  storageBucket: "pipaan-app-dev.firebasestorage.app",
  messagingSenderId: "706590898626",
  appId: "1:706590898626:web:ef4359b00380649a78be5b",
  measurementId: "G-7HVFFTMVQG"
};


const app = initializeApp(firebaseConfig);
console.log("Firebase initialized:", app.name);

const messaging = getMessaging(app);

export { messaging, getToken, onMessage };
